import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { Deck, GetDecksResponse, VisibilityType } from "@apiserver-rest/ponder-data-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { DeckPreviewComponent } from "../decks/deck-preview/deck-preview.component";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AuthSession } from "@ponder-core/auth/auth-session";

@Component({
    selector: "profile-deck-previews",
    imports: [LoadingComponent, DeckPreviewComponent],
    templateUrl: "./deck-previews.component.html"
})
export class ProfileDeckPreviewsComponent {
    @Input({ required: true }) public username!: string;

    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public isVisible: boolean = true;
    public isOwnDecks: boolean = false;
    public decks: Deck[] = [];
    public origDeckCount: number = 0;

    constructor(private ponderDataClient: PonderDataClient, private auth: AuthService) {

    }

    public ngOnInit(): void {
        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession) {
                this.isOwnDecks = this.username == authSession.username;
            }
        });

        this.ponderDataClient.decks(this.username).subscribe({
            next: (response: GetDecksResponse) => {
                if (response.success) {
                    if (response.isVisible) {
                        var allDecks = response.decks ?? [];

                        allDecks.forEach(d => {
                            if (d.visibility == VisibilityType.Public) {
                                this.decks.push(d);
                            }
                        });
                        
                        this.origDeckCount = this.decks.length;

                        this.decks = this.decks.sort((a, b) => {
                            // For now, just sort decks by most recently updated.
                            // todo in the future when we add pinned/favorite/whatever decks show those first.
                            var aTime = (a.updatedAt ?? a.createdAt);
                            var bTime = (b.updatedAt ?? b.createdAt);

                            return (bTime.getTime() - aTime.getTime());
                        }).slice(0, 6);
                    } else {
                        this.isVisible = false;
                    }                    

                    this.loadingSuccess = true;
                }
            }
        }).add(() => { this.isLoading = false; });
    }
}